import { CSSProperties, PropsWithChildren } from "react";

import { Caption } from "@components/Typography";
import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export type SidecarBadgeProps = PropsWithChildren<{
  style?: CSSProperties;
}>;

/**
 * Light theme counterpart of mobile's ChromeBadge: a centered uppercase pill
 * used to label the contribution steppers.
 */
export const SidecarBadge = ({ children, style }: SidecarBadgeProps) => {
  const { theme } = useTheme();

  return (
    <div
      style={{
        alignSelf: "center",
        margin: "0 auto",
        padding: `${spacing.xxs}px ${spacing.l}px`,
        borderRadius: constants.radius.button,
        border: `1px solid ${theme.border}`,
        backgroundColor: theme.input.background,
        ...style,
      }}
    >
      <Caption
        style={{
          margin: 0,
          fontSize: 10,
          fontWeight: 700,
          textAlign: "center",
          textTransform: "uppercase",
          color: theme.text.secondary,
        }}
      >
        {children}
      </Caption>
    </div>
  );
};
